export default () => ({
  uuid: null,
  addresses: [],
  accessToken: '',
  all: [],
  creditAmount: '',
  externalId: null,
  phone: '',
  name: '',
  email: '',
  postalCode: '',
  address: '',
  extra: '',
  items: [],
  isInternal: false,
  isLoggedIn: false,
  orders: null,
  paymentMethods: [],
  pushToken: '',
  role: null,
});
